import { render } from "./TitleLarge.vue?vue&type=template&id=7d850700&scoped=true"
const script = {}

import "./TitleLarge.vue?vue&type=style&index=0&id=7d850700&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d850700"]])

export default __exports__